__turbopack_context__.v({
  "body-20": "bento-one-module-scss-module__BhYO3q__body-20",
  "body-20--lg": "bento-one-module-scss-module__BhYO3q__body-20--lg",
  "body-20--md": "bento-one-module-scss-module__BhYO3q__body-20--md",
  "body-20--sm": "bento-one-module-scss-module__BhYO3q__body-20--sm",
  "body-20--tablet": "bento-one-module-scss-module__BhYO3q__body-20--tablet",
  "body-20--xl": "bento-one-module-scss-module__BhYO3q__body-20--xl",
  "body-20--xs": "bento-one-module-scss-module__BhYO3q__body-20--xs",
  "body-20--xxs": "bento-one-module-scss-module__BhYO3q__body-20--xxs",
  "body-2xl": "bento-one-module-scss-module__BhYO3q__body-2xl",
  "body-2xl--lg": "bento-one-module-scss-module__BhYO3q__body-2xl--lg",
  "body-2xl--md": "bento-one-module-scss-module__BhYO3q__body-2xl--md",
  "body-2xl--sm": "bento-one-module-scss-module__BhYO3q__body-2xl--sm",
  "body-2xl--tablet": "bento-one-module-scss-module__BhYO3q__body-2xl--tablet",
  "body-2xl--xl": "bento-one-module-scss-module__BhYO3q__body-2xl--xl",
  "body-2xl--xs": "bento-one-module-scss-module__BhYO3q__body-2xl--xs",
  "body-2xl--xxs": "bento-one-module-scss-module__BhYO3q__body-2xl--xxs",
  "body-2xs": "bento-one-module-scss-module__BhYO3q__body-2xs",
  "body-2xs--lg": "bento-one-module-scss-module__BhYO3q__body-2xs--lg",
  "body-2xs--md": "bento-one-module-scss-module__BhYO3q__body-2xs--md",
  "body-2xs--sm": "bento-one-module-scss-module__BhYO3q__body-2xs--sm",
  "body-2xs--tablet": "bento-one-module-scss-module__BhYO3q__body-2xs--tablet",
  "body-2xs--xl": "bento-one-module-scss-module__BhYO3q__body-2xs--xl",
  "body-2xs--xs": "bento-one-module-scss-module__BhYO3q__body-2xs--xs",
  "body-2xs--xxs": "bento-one-module-scss-module__BhYO3q__body-2xs--xxs",
  "body-3xl": "bento-one-module-scss-module__BhYO3q__body-3xl",
  "body-3xl--lg": "bento-one-module-scss-module__BhYO3q__body-3xl--lg",
  "body-3xl--md": "bento-one-module-scss-module__BhYO3q__body-3xl--md",
  "body-3xl--sm": "bento-one-module-scss-module__BhYO3q__body-3xl--sm",
  "body-3xl--tablet": "bento-one-module-scss-module__BhYO3q__body-3xl--tablet",
  "body-3xl--xl": "bento-one-module-scss-module__BhYO3q__body-3xl--xl",
  "body-3xl--xs": "bento-one-module-scss-module__BhYO3q__body-3xl--xs",
  "body-3xl--xxs": "bento-one-module-scss-module__BhYO3q__body-3xl--xxs",
  "body-3xs": "bento-one-module-scss-module__BhYO3q__body-3xs",
  "body-3xs--lg": "bento-one-module-scss-module__BhYO3q__body-3xs--lg",
  "body-3xs--md": "bento-one-module-scss-module__BhYO3q__body-3xs--md",
  "body-3xs--sm": "bento-one-module-scss-module__BhYO3q__body-3xs--sm",
  "body-3xs--tablet": "bento-one-module-scss-module__BhYO3q__body-3xs--tablet",
  "body-3xs--xl": "bento-one-module-scss-module__BhYO3q__body-3xs--xl",
  "body-3xs--xs": "bento-one-module-scss-module__BhYO3q__body-3xs--xs",
  "body-3xs--xxs": "bento-one-module-scss-module__BhYO3q__body-3xs--xxs",
  "body-lg": "bento-one-module-scss-module__BhYO3q__body-lg",
  "body-lg--lg": "bento-one-module-scss-module__BhYO3q__body-lg--lg",
  "body-lg--md": "bento-one-module-scss-module__BhYO3q__body-lg--md",
  "body-lg--sm": "bento-one-module-scss-module__BhYO3q__body-lg--sm",
  "body-lg--tablet": "bento-one-module-scss-module__BhYO3q__body-lg--tablet",
  "body-lg--xl": "bento-one-module-scss-module__BhYO3q__body-lg--xl",
  "body-lg--xs": "bento-one-module-scss-module__BhYO3q__body-lg--xs",
  "body-lg--xxs": "bento-one-module-scss-module__BhYO3q__body-lg--xxs",
  "body-md": "bento-one-module-scss-module__BhYO3q__body-md",
  "body-md--lg": "bento-one-module-scss-module__BhYO3q__body-md--lg",
  "body-md--md": "bento-one-module-scss-module__BhYO3q__body-md--md",
  "body-md--sm": "bento-one-module-scss-module__BhYO3q__body-md--sm",
  "body-md--tablet": "bento-one-module-scss-module__BhYO3q__body-md--tablet",
  "body-md--xl": "bento-one-module-scss-module__BhYO3q__body-md--xl",
  "body-md--xs": "bento-one-module-scss-module__BhYO3q__body-md--xs",
  "body-md--xxs": "bento-one-module-scss-module__BhYO3q__body-md--xxs",
  "body-xl": "bento-one-module-scss-module__BhYO3q__body-xl",
  "body-xl--lg": "bento-one-module-scss-module__BhYO3q__body-xl--lg",
  "body-xl--md": "bento-one-module-scss-module__BhYO3q__body-xl--md",
  "body-xl--sm": "bento-one-module-scss-module__BhYO3q__body-xl--sm",
  "body-xl--tablet": "bento-one-module-scss-module__BhYO3q__body-xl--tablet",
  "body-xl--xl": "bento-one-module-scss-module__BhYO3q__body-xl--xl",
  "body-xl--xs": "bento-one-module-scss-module__BhYO3q__body-xl--xs",
  "body-xl--xxs": "bento-one-module-scss-module__BhYO3q__body-xl--xxs",
  "body-xs": "bento-one-module-scss-module__BhYO3q__body-xs",
  "body-xs--lg": "bento-one-module-scss-module__BhYO3q__body-xs--lg",
  "body-xs--md": "bento-one-module-scss-module__BhYO3q__body-xs--md",
  "body-xs--sm": "bento-one-module-scss-module__BhYO3q__body-xs--sm",
  "body-xs--tablet": "bento-one-module-scss-module__BhYO3q__body-xs--tablet",
  "body-xs--xl": "bento-one-module-scss-module__BhYO3q__body-xs--xl",
  "body-xs--xs": "bento-one-module-scss-module__BhYO3q__body-xs--xs",
  "body-xs--xxs": "bento-one-module-scss-module__BhYO3q__body-xs--xxs",
  "button": "bento-one-module-scss-module__BhYO3q__button",
  "button-left": "bento-one-module-scss-module__BhYO3q__button-left",
  "button-right": "bento-one-module-scss-module__BhYO3q__button-right",
  "carousel": "bento-one-module-scss-module__BhYO3q__carousel",
  "chevron": "bento-one-module-scss-module__BhYO3q__chevron",
  "container": "bento-one-module-scss-module__BhYO3q__container",
  "flexContainer": "bento-one-module-scss-module__BhYO3q__flexContainer",
  "heading-120": "bento-one-module-scss-module__BhYO3q__heading-120",
  "heading-120--lg": "bento-one-module-scss-module__BhYO3q__heading-120--lg",
  "heading-120--md": "bento-one-module-scss-module__BhYO3q__heading-120--md",
  "heading-120--sm": "bento-one-module-scss-module__BhYO3q__heading-120--sm",
  "heading-120--tablet": "bento-one-module-scss-module__BhYO3q__heading-120--tablet",
  "heading-120--xl": "bento-one-module-scss-module__BhYO3q__heading-120--xl",
  "heading-120--xs": "bento-one-module-scss-module__BhYO3q__heading-120--xs",
  "heading-120--xxs": "bento-one-module-scss-module__BhYO3q__heading-120--xxs",
  "heading-128": "bento-one-module-scss-module__BhYO3q__heading-128",
  "heading-128--lg": "bento-one-module-scss-module__BhYO3q__heading-128--lg",
  "heading-128--md": "bento-one-module-scss-module__BhYO3q__heading-128--md",
  "heading-128--sm": "bento-one-module-scss-module__BhYO3q__heading-128--sm",
  "heading-128--tablet": "bento-one-module-scss-module__BhYO3q__heading-128--tablet",
  "heading-128--xl": "bento-one-module-scss-module__BhYO3q__heading-128--xl",
  "heading-128--xs": "bento-one-module-scss-module__BhYO3q__heading-128--xs",
  "heading-128--xxs": "bento-one-module-scss-module__BhYO3q__heading-128--xxs",
  "heading-150": "bento-one-module-scss-module__BhYO3q__heading-150",
  "heading-150--lg": "bento-one-module-scss-module__BhYO3q__heading-150--lg",
  "heading-150--md": "bento-one-module-scss-module__BhYO3q__heading-150--md",
  "heading-150--sm": "bento-one-module-scss-module__BhYO3q__heading-150--sm",
  "heading-150--tablet": "bento-one-module-scss-module__BhYO3q__heading-150--tablet",
  "heading-150--xl": "bento-one-module-scss-module__BhYO3q__heading-150--xl",
  "heading-150--xs": "bento-one-module-scss-module__BhYO3q__heading-150--xs",
  "heading-150--xxs": "bento-one-module-scss-module__BhYO3q__heading-150--xxs",
  "heading-2xl": "bento-one-module-scss-module__BhYO3q__heading-2xl",
  "heading-2xl--lg": "bento-one-module-scss-module__BhYO3q__heading-2xl--lg",
  "heading-2xl--md": "bento-one-module-scss-module__BhYO3q__heading-2xl--md",
  "heading-2xl--sm": "bento-one-module-scss-module__BhYO3q__heading-2xl--sm",
  "heading-2xl--tablet": "bento-one-module-scss-module__BhYO3q__heading-2xl--tablet",
  "heading-2xl--xl": "bento-one-module-scss-module__BhYO3q__heading-2xl--xl",
  "heading-2xl--xs": "bento-one-module-scss-module__BhYO3q__heading-2xl--xs",
  "heading-2xl--xxs": "bento-one-module-scss-module__BhYO3q__heading-2xl--xxs",
  "heading-3xl": "bento-one-module-scss-module__BhYO3q__heading-3xl",
  "heading-3xl--lg": "bento-one-module-scss-module__BhYO3q__heading-3xl--lg",
  "heading-3xl--md": "bento-one-module-scss-module__BhYO3q__heading-3xl--md",
  "heading-3xl--sm": "bento-one-module-scss-module__BhYO3q__heading-3xl--sm",
  "heading-3xl--tablet": "bento-one-module-scss-module__BhYO3q__heading-3xl--tablet",
  "heading-3xl--xl": "bento-one-module-scss-module__BhYO3q__heading-3xl--xl",
  "heading-3xl--xs": "bento-one-module-scss-module__BhYO3q__heading-3xl--xs",
  "heading-3xl--xxs": "bento-one-module-scss-module__BhYO3q__heading-3xl--xxs",
  "heading-4xl": "bento-one-module-scss-module__BhYO3q__heading-4xl",
  "heading-4xl--lg": "bento-one-module-scss-module__BhYO3q__heading-4xl--lg",
  "heading-4xl--md": "bento-one-module-scss-module__BhYO3q__heading-4xl--md",
  "heading-4xl--sm": "bento-one-module-scss-module__BhYO3q__heading-4xl--sm",
  "heading-4xl--tablet": "bento-one-module-scss-module__BhYO3q__heading-4xl--tablet",
  "heading-4xl--xl": "bento-one-module-scss-module__BhYO3q__heading-4xl--xl",
  "heading-4xl--xs": "bento-one-module-scss-module__BhYO3q__heading-4xl--xs",
  "heading-4xl--xxs": "bento-one-module-scss-module__BhYO3q__heading-4xl--xxs",
  "heading-5xl": "bento-one-module-scss-module__BhYO3q__heading-5xl",
  "heading-5xl--lg": "bento-one-module-scss-module__BhYO3q__heading-5xl--lg",
  "heading-5xl--md": "bento-one-module-scss-module__BhYO3q__heading-5xl--md",
  "heading-5xl--sm": "bento-one-module-scss-module__BhYO3q__heading-5xl--sm",
  "heading-5xl--tablet": "bento-one-module-scss-module__BhYO3q__heading-5xl--tablet",
  "heading-5xl--xl": "bento-one-module-scss-module__BhYO3q__heading-5xl--xl",
  "heading-5xl--xs": "bento-one-module-scss-module__BhYO3q__heading-5xl--xs",
  "heading-5xl--xxs": "bento-one-module-scss-module__BhYO3q__heading-5xl--xxs",
  "heading-60": "bento-one-module-scss-module__BhYO3q__heading-60",
  "heading-60--lg": "bento-one-module-scss-module__BhYO3q__heading-60--lg",
  "heading-60--md": "bento-one-module-scss-module__BhYO3q__heading-60--md",
  "heading-60--sm": "bento-one-module-scss-module__BhYO3q__heading-60--sm",
  "heading-60--tablet": "bento-one-module-scss-module__BhYO3q__heading-60--tablet",
  "heading-60--xl": "bento-one-module-scss-module__BhYO3q__heading-60--xl",
  "heading-60--xs": "bento-one-module-scss-module__BhYO3q__heading-60--xs",
  "heading-60--xxs": "bento-one-module-scss-module__BhYO3q__heading-60--xxs",
  "heading-70": "bento-one-module-scss-module__BhYO3q__heading-70",
  "heading-70--lg": "bento-one-module-scss-module__BhYO3q__heading-70--lg",
  "heading-70--md": "bento-one-module-scss-module__BhYO3q__heading-70--md",
  "heading-70--sm": "bento-one-module-scss-module__BhYO3q__heading-70--sm",
  "heading-70--tablet": "bento-one-module-scss-module__BhYO3q__heading-70--tablet",
  "heading-70--xl": "bento-one-module-scss-module__BhYO3q__heading-70--xl",
  "heading-70--xs": "bento-one-module-scss-module__BhYO3q__heading-70--xs",
  "heading-70--xxs": "bento-one-module-scss-module__BhYO3q__heading-70--xxs",
  "heading-90": "bento-one-module-scss-module__BhYO3q__heading-90",
  "heading-90--lg": "bento-one-module-scss-module__BhYO3q__heading-90--lg",
  "heading-90--md": "bento-one-module-scss-module__BhYO3q__heading-90--md",
  "heading-90--sm": "bento-one-module-scss-module__BhYO3q__heading-90--sm",
  "heading-90--tablet": "bento-one-module-scss-module__BhYO3q__heading-90--tablet",
  "heading-90--xl": "bento-one-module-scss-module__BhYO3q__heading-90--xl",
  "heading-90--xs": "bento-one-module-scss-module__BhYO3q__heading-90--xs",
  "heading-90--xxs": "bento-one-module-scss-module__BhYO3q__heading-90--xxs",
  "heading-lg": "bento-one-module-scss-module__BhYO3q__heading-lg",
  "heading-lg--lg": "bento-one-module-scss-module__BhYO3q__heading-lg--lg",
  "heading-lg--md": "bento-one-module-scss-module__BhYO3q__heading-lg--md",
  "heading-lg--sm": "bento-one-module-scss-module__BhYO3q__heading-lg--sm",
  "heading-lg--tablet": "bento-one-module-scss-module__BhYO3q__heading-lg--tablet",
  "heading-lg--xl": "bento-one-module-scss-module__BhYO3q__heading-lg--xl",
  "heading-lg--xs": "bento-one-module-scss-module__BhYO3q__heading-lg--xs",
  "heading-lg--xxs": "bento-one-module-scss-module__BhYO3q__heading-lg--xxs",
  "heading-md": "bento-one-module-scss-module__BhYO3q__heading-md",
  "heading-md--lg": "bento-one-module-scss-module__BhYO3q__heading-md--lg",
  "heading-md--md": "bento-one-module-scss-module__BhYO3q__heading-md--md",
  "heading-md--sm": "bento-one-module-scss-module__BhYO3q__heading-md--sm",
  "heading-md--tablet": "bento-one-module-scss-module__BhYO3q__heading-md--tablet",
  "heading-md--xl": "bento-one-module-scss-module__BhYO3q__heading-md--xl",
  "heading-md--xs": "bento-one-module-scss-module__BhYO3q__heading-md--xs",
  "heading-md--xxs": "bento-one-module-scss-module__BhYO3q__heading-md--xxs",
  "heading-sm": "bento-one-module-scss-module__BhYO3q__heading-sm",
  "heading-sm--lg": "bento-one-module-scss-module__BhYO3q__heading-sm--lg",
  "heading-sm--md": "bento-one-module-scss-module__BhYO3q__heading-sm--md",
  "heading-sm--sm": "bento-one-module-scss-module__BhYO3q__heading-sm--sm",
  "heading-sm--tablet": "bento-one-module-scss-module__BhYO3q__heading-sm--tablet",
  "heading-sm--xl": "bento-one-module-scss-module__BhYO3q__heading-sm--xl",
  "heading-sm--xs": "bento-one-module-scss-module__BhYO3q__heading-sm--xs",
  "heading-sm--xxs": "bento-one-module-scss-module__BhYO3q__heading-sm--xxs",
  "heading-xl": "bento-one-module-scss-module__BhYO3q__heading-xl",
  "heading-xl--lg": "bento-one-module-scss-module__BhYO3q__heading-xl--lg",
  "heading-xl--md": "bento-one-module-scss-module__BhYO3q__heading-xl--md",
  "heading-xl--sm": "bento-one-module-scss-module__BhYO3q__heading-xl--sm",
  "heading-xl--tablet": "bento-one-module-scss-module__BhYO3q__heading-xl--tablet",
  "heading-xl--xl": "bento-one-module-scss-module__BhYO3q__heading-xl--xl",
  "heading-xl--xs": "bento-one-module-scss-module__BhYO3q__heading-xl--xs",
  "heading-xl--xxs": "bento-one-module-scss-module__BhYO3q__heading-xl--xxs",
  "heading-xs": "bento-one-module-scss-module__BhYO3q__heading-xs",
  "heading-xs--lg": "bento-one-module-scss-module__BhYO3q__heading-xs--lg",
  "heading-xs--md": "bento-one-module-scss-module__BhYO3q__heading-xs--md",
  "heading-xs--sm": "bento-one-module-scss-module__BhYO3q__heading-xs--sm",
  "heading-xs--tablet": "bento-one-module-scss-module__BhYO3q__heading-xs--tablet",
  "heading-xs--xl": "bento-one-module-scss-module__BhYO3q__heading-xs--xl",
  "heading-xs--xs": "bento-one-module-scss-module__BhYO3q__heading-xs--xs",
  "heading-xs--xxs": "bento-one-module-scss-module__BhYO3q__heading-xs--xxs",
  "heading-xxs": "bento-one-module-scss-module__BhYO3q__heading-xxs",
  "heading-xxs--lg": "bento-one-module-scss-module__BhYO3q__heading-xxs--lg",
  "heading-xxs--md": "bento-one-module-scss-module__BhYO3q__heading-xxs--md",
  "heading-xxs--sm": "bento-one-module-scss-module__BhYO3q__heading-xxs--sm",
  "heading-xxs--tablet": "bento-one-module-scss-module__BhYO3q__heading-xxs--tablet",
  "heading-xxs--xl": "bento-one-module-scss-module__BhYO3q__heading-xxs--xl",
  "heading-xxs--xs": "bento-one-module-scss-module__BhYO3q__heading-xxs--xs",
  "heading-xxs--xxs": "bento-one-module-scss-module__BhYO3q__heading-xxs--xxs",
  "large-prompt": "bento-one-module-scss-module__BhYO3q__large-prompt",
  "large-prompt--lg": "bento-one-module-scss-module__BhYO3q__large-prompt--lg",
  "large-prompt--md": "bento-one-module-scss-module__BhYO3q__large-prompt--md",
  "large-prompt--sm": "bento-one-module-scss-module__BhYO3q__large-prompt--sm",
  "large-prompt--tablet": "bento-one-module-scss-module__BhYO3q__large-prompt--tablet",
  "large-prompt--xl": "bento-one-module-scss-module__BhYO3q__large-prompt--xl",
  "large-prompt--xs": "bento-one-module-scss-module__BhYO3q__large-prompt--xs",
  "large-prompt--xxs": "bento-one-module-scss-module__BhYO3q__large-prompt--xxs",
});
